// @ts-nocheck
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import './PaymentDetailsSkeleton.css';
import * as PropTypes from 'prop-types';

/**
 * Functional React component for rendering a custom skeleton for the payment details content.
 *
 * @namespace Components
 *
 * @param {Object} props - The properties of the component.
 * @param {string} props.id - The unique identifier for the component.
 *
 * @returns {JSX.Element} - The rendered skeleton for the payment details.
 */

const PaymentDetailsSkeleton = ({ id }) => {
  return (
    <Box className='payment-details__skeleton' id={id}>
      <Box className='payment-details__skeleton__row'>
        <Skeleton
          variant='text'
          width={120}
          height={30}
          sx={{ backgroundColor: 'rgba(0, 0, 0, 0.06)' }}
        />
        <Skeleton
          variant='text'
          width={80}
          height={30}
          sx={{ backgroundColor: 'rgba(0, 0, 0, 0.06)' }}
        />
      </Box>
      <Box className='payment-details__skeleton__row'>
        <Skeleton
          variant='text'
          width={100}
          height={30}
          sx={{ backgroundColor: 'rgba(0, 0, 0, 0.06)' }}
        />
        <Skeleton
          variant='text'
          width={90}
          height={30}
          sx={{ backgroundColor: 'rgba(0, 0, 0, 0.06)' }}
        />
      </Box>
      <Box className='payment-details__skeleton__row'>
        <Skeleton
          variant='text'
          width={130}
          height={30}
          sx={{ backgroundColor: 'rgba(0, 0, 0, 0.06)' }}
        />
        <Skeleton
          variant='text'
          width={100}
          height={30}
          sx={{ backgroundColor: 'rgba(0, 0, 0, 0.06)' }}
        />
      </Box>
    </Box>
  );
};

/**
 * Prop type definitions for PaymentDetailsSkeleton.
 */
PaymentDetailsSkeleton.propTypes = {
  id: PropTypes.string.isRequired
};

export default PaymentDetailsSkeleton;
